import { BehaviorSubject, Observable, throwError, of } from 'rxjs';
import { IResponseStructFireBase } from "./../../interfaces/shared/struct-firebase.interface";
import { IDomainVerify } from "./../../interfaces/pages/abm/domain-verify.interface";

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { GenerateTokenService, Token } from 'integrationpingid-lib';
import { first, timeout, retry, catchError, tap } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';
import { ChangeDetails, ChangeObservations, DMS } from 'src/app/entities/ar/DMS';
import { Persona } from 'src/app/entities/shared/Persona';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { FormGroup } from '@angular/forms';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';

import { Country } from 'src/app/entities/shared/Country';

import { User } from 'src/app/entities/shared/User';
import COUNTRIES from 'src/assets/data/shared/COUNTRIES.json'; // flags faltantes en https://www.pngaaa.com/search/chile-png-icon/
import LOGIN from 'src/assets/data/shared/LOGIN.json';
import { OptionMenuApps } from 'src/app/enums/shared';
import { UrlService } from './url.service';
import { CacheService } from './cache/cache.service';

interface IselectValuesStruct {
  text: string;
  value: string;
  multiCode?: string;
  codeRef?: string;
}

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  serviceName = "SharedService";

  now: Date = new Date();
  minDate = { year: 1900, month: 1, day: 1 };
  maxDate = { year: this.now.getFullYear(), month: this.now.getMonth() + 1, day: this.now.getDate() };
  currentPersona: Persona;

  objParams = {
    headers: this.getTokenToHeaders()
  };

  urlReturnApp: string = '';
  clientId: string = '';
  firstBaseUrl: string = '';
  secondBaseUrl: string = '';
  redirectUrl: string = '';

  stringTokenLS = '=yJ1c2V';
  sourcesSpecific: Array<string> = [];

  mivisualizadorBloqueo = new BehaviorSubject<boolean>(false);
  urlJournaling: string = "";

  constructor(
    private http: HttpClient,
    public serviceToken: GenerateTokenService,
    private router: Router,
    private notificationService: NotificationService,
    private localStorageService: LocalStorageService,
    private urlService: UrlService,
    private cacheService: CacheService,
  ) { }

  get country(): string {
    return this.localStorageService.getRegionSeleccionada?.getCode()?.toUpperCase();
  }

  setdataBloqueo(data: boolean) {
    return this.mivisualizadorBloqueo.next(data);
  }

  getdataBloqueo() {
    return this.mivisualizadorBloqueo.asObservable();
  }

  getCountry() {
    return COUNTRIES;
  }

  getHistory(
    country: string,
    domain: string,
    subDomain: string,
    matchkey: string
  ) {
    // En ambiente local usar proxy
    if (String(environment.IS_LOCAL.toLowerCase()) === 'true') {
      const url = `/journaling-service/api/v2/sources/history/${country}/${domain}/${subDomain}`;
      return this.http.get(url, { params: { matchkey } })
        .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    }

    // cambio para ruta de Microservicios
    let rutaMicroservicio = environment.MICROSERVICIO.toString().toLowerCase() === "true"
      ? this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"] + "/"
      : "";

    let urlBaseApi = this.localStorageService.getIsVip
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    let apiVip = this.localStorageService.getIsVip
      ? "vip/journaling-service"
      : rutaMicroservicio + "api";
    const url = `${urlBaseApi}/${apiVip}/v2/sources/history/${country}/${domain}/${subDomain}`;

    return this.http.get(url, { params: { matchkey } })
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  multiCodeSelectStruc(
    valueSelect: IselectValuesStruct[],
    data: number | string
  ) {
    valueSelect.forEach((value: IselectValuesStruct) => {
      if (value.multiCode) {
        const separacion = value.multiCode.split(".");
        if (separacion[0] != data.toString())
          for (const valueSep of separacion) {
            if (valueSep === data.toString()) {
              data = value.value;
              break;
            }
          }
      }
    });
    return data;
  }

  getTokenToHeaders() {
    let headerDict: { Authorization: string; };
    if (this.localStorageService.getIsVip) {
      headerDict = {
        Authorization: "Bearer " + localStorage.getItem('access_token')
      };
    } else {
      let token: Token = {};
      if (this.serviceToken.statusTokenUser()) {
        token = this.serviceToken.getTokenUser();
      } else {
        // This is intentional
      }
      headerDict = {
        Authorization: token.token_type + " " + token.access_token,
      };
    }
    return headerDict;
  }

  handlePeruSpecialCase(domain: string, subDomain: string): { effectiveDomain: string, effectiveSubDomain: string } {
    const isPeruSpecialCase = this.country === 'PE' &&
      domain === 'PE_COMMERCIAL_IDENTITY' &&
      subDomain === 'COMMERCIAL_RELATIONSHIPS';

    if (isPeruSpecialCase) {
      return {
        effectiveDomain: 'PE_COMMERCIAL_IDENTITY',
        effectiveSubDomain: 'RELATIONSHIPS'
      };
    }

    return { effectiveDomain: domain, effectiveSubDomain: subDomain };
  }

  getSchemasDataViewsShared(domain: string, subDomain: string) {
    const { effectiveDomain, effectiveSubDomain } = this.handlePeruSpecialCase(domain, subDomain);

    const cacheKey = `schema|${this.country}|${effectiveDomain}|${effectiveSubDomain}`;
    const cached = this.cacheService.get(cacheKey);
    if (cached) {
      return of(cached);
    }

    const isRds = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS || this.localStorageService.isMenuRds();

    // cambio para ruta de Microservicios
    let rutaMicroservicio = environment.MICROSERVICIO.toString().toLowerCase() === "true"
      ? this.localStorageService.configInit["F_URL_MS_IM_DIS"] + "/"
      : "";
    if (isRds) {
      rutaMicroservicio = this.localStorageService.configInit["F_URL_MS_IM_RDS"] + "/"
    }

    // rutas para VIP
    let urlBaseApi = this.localStorageService.getIsVip
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    let rutaDataview = this.localStorageService.getIsVip
      ? this.localStorageService.configInit["F_VIP_URL_DATAVIEW"]
      : rutaMicroservicio + this.localStorageService.configInit["F_URL_DATAWIEW"];
    let rutaDataviewFinal = isRds
      ? rutaMicroservicio + this.localStorageService.configInit["F_PINGID_URL_DATAVIEW_RDS"]
      : rutaDataview;

    // Se usan las variables 'effectiveDomain' y 'effectiveSubDomain'
    let url = `${urlBaseApi}/${rutaDataviewFinal}/${this.country}/${effectiveDomain}/${effectiveSubDomain}`;
    if (isRds) {
      url = `${urlBaseApi}/${rutaDataviewFinal}/${this.country}/${effectiveSubDomain}`;
    }
    if (!(environment.CONSUME_API_SCHEMA.toString().toLowerCase() === "true")) {
      url = `assets/mock/${this.country.toLocaleLowerCase()}/dataview_schema/DATAVIEW_${effectiveDomain}_${effectiveSubDomain}.json`;
    }
    return this.http.get<any>(url)
      .pipe(
        retry({
          count: 3,
          delay: (error, retryCount) => {
            // Parsear el codigo del string que retorna el interceptor: "Codigo: 429, Mensaje: ..."
            const errorCode = typeof error === 'string' && error.includes('Código:')
              ? parseInt(error.split('Código:')[1].split(',')[0].trim())
              : (error?.status || -1);

            // Solo reintentar si es error 429 (Too Many Requests)
            if (errorCode === 429) {
              console.log(`Reintento ${retryCount} de 3 por error 429 en getSchemasDataViewsShared`);
              return of(null).pipe(timeout(2000)); // Esperar 2 segundos
            }
            // Para otros errores, lanzar error inmediatamente
            return throwError(() => error);
          }
        }),
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        tap(response => this.cacheService.set(cacheKey, response))
      );
  }

  optionType(val: any) {
    if (typeof val === "object") {
      return val.type;
    } else {
      return val;
    }
  }

  convertFormatDIS(typeFormat: any, value: any) {
    let valueFinal = value;
    // console.log("typeFormat, valueFinal", typeFormat, valueFinal);
    if (value !== undefined && value !== null && typeof typeFormat === "string") {
      switch (typeFormat.toLowerCase().trim()) {
        case "string":
        case "char":
        case "caracter":
        case "text":
          valueFinal = value.toString();
          break;
        case "int":
        case "integer":
        case "number":
        case "numerico":
        case "numérico":
          valueFinal = (value === "")
            ? null
            : Number(value);
          break;
        case "long":
          valueFinal = (value === "")
            ? null
            : BigInt(value);
          break;
        case "bigint":
          valueFinal = (value === "")
            ? null
            : BigInt(value);
          break;
        case "float":
        case "double":
          valueFinal = (value === "")
            ? null
            : parseFloat(value);
          break;
        case "boolean":
          valueFinal = String(value).toLowerCase() === "true";
          break;
        default:
          valueFinal = value; // No hace nada si el tipo no está mapeado
          break;
      }
    }
    // console.log("value, typeFormat, valueFinal");
    // console.log(value, typeFormat, valueFinal);
    return valueFinal;
  }

  // se ocupa en setAllPeriods()
  convertFormatDISOld(typeFormat: string, value: any) {
    let valueFinal = value;
    // console.log("typeFormat, valueFinal", typeFormat, valueFinal);
    if (value !== undefined && value !== null) {
      switch (typeFormat.toLowerCase().trim()) {
        case "string":
        case "char":
        case "caracter":
        case "text":
          valueFinal = `"${this.escapeSpecialCharsDIS(value.toString())}"`;
          // valueFinal = `"${String(value)}"`;
          break;
        case "int":
        case "integer":
        case "number":
        case "numerico":
        case "numérico":
          valueFinal = (value === "")
            ? null
            : parseInt(value);
          break;
        case "long":
          valueFinal = (value === "")
            ? null
            : BigInt(value);
          break;
        case "bigint":
          valueFinal = (value === "")
            ? null
            : BigInt(value);
          break;
        case "float":
        case "double":
          valueFinal = (value === "")
            ? null
            : parseFloat(value);
          break;
        case "boolean":
          valueFinal = String(value).toLowerCase() === "true";
          break;
        default:
          valueFinal = "";
          break;
      }
    }
    // console.log("value, typeFormat, valueFinal");
    // console.log(value, typeFormat, valueFinal);
    return valueFinal;
  }

  formatDate(date: string) {
    if (date && date.toString().length === 8) {
      return {
        year: date.toString().substring(0, 4),
        month: date.toString().substring(4, 6),
        day: date.toString().substring(6, 8),
      };
    }
  }

  validateFormatDate(pattern: string, value: string): string {
    if (!pattern || !value) {
      return "";
    }

    let year: number, month: number, day: number | undefined;
    let yearStr: string = '', monthStr: string = '', dayStr: string = '';

    const normalizedPattern = pattern.toUpperCase().replace(/A/g, 'Y');

    switch (normalizedPattern) {
      case 'YYYYMMDD':
        if (value.length === 8 && /^\d{8}$/.test(value)) {
          yearStr = value.substring(0, 4);
          monthStr = value.substring(4, 6);
          dayStr = value.substring(6, 8);
        } else {
          return "";
        }
        break;

      case 'DDMMYYYY':
        if (value.length === 8 && /^\d{8}$/.test(value)) {
          dayStr = value.substring(0, 2);
          monthStr = value.substring(2, 4);
          yearStr = value.substring(4, 8);
        } else {
          return "";
        }
        break;

      case 'YYYY-MM-DD':
        if (value.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
          [yearStr, monthStr, dayStr] = value.split('-');
        } else {
          return "";
        }
        break;

      case 'DD-MM-YYYY':
        if (value.length === 10 && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
          [dayStr, monthStr, yearStr] = value.split('-');
        } else {
          return "";
        }
        break;

      case 'YYYYMM':
        if (value.length === 6 && /^\d{6}$/.test(value)) {
          yearStr = value.substring(0, 4);
          monthStr = value.substring(4, 6);
          dayStr = "01";
        } else {
          return "";
        }
        break;

      case 'YYYY-MM':
        if (value.length === 7 && /^\d{4}-\d{2}$/.test(value)) {
          [yearStr, monthStr] = value.split('-');
          dayStr = "01";
        } else {
          return "";
        }
        break;

      default:
        console.warn(`Patrón de fecha no reconocido: ${pattern}`);
        return "";
    }

    year = parseInt(yearStr, 10);
    month = parseInt(monthStr, 10);
    if (dayStr) {
      day = parseInt(dayStr, 10);
    }

    if (!this.isValidDateParts(year, month, day)) {
      return "";
    }

    if (normalizedPattern === 'YYYYMM' || normalizedPattern === 'YYYY-MM') {
      return `${yearStr}-${monthStr}`;
    } else {
      return `${yearStr}-${monthStr.padStart(2, '0')}-${dayStr.padStart(2, '0')}`;
    }
  }


  isValidDateParts(year: number, month: number, day?: number): boolean {
    if (isNaN(year) || isNaN(month) || (day !== undefined && isNaN(day))) {
      return false;
    }

    if (year < 1000 || year > 9999) {
      return false;
    }
    if (month < 1 || month > 12) {
      return false;
    }

    if (day !== undefined) {
      if (day < 1 || day > 31) {
        return false;
      }
      const dateObj = new Date(year, month - 1, day);
      return dateObj.getFullYear() === year &&
        dateObj.getMonth() === month - 1 &&
        dateObj.getDate() === day;
    } else {
      return true;
    }
  }

  getDetailsShared(
    dataObject: any,
    country: string,
    domain: string,
    subDomain: string,
    mode?: any
  ) {
    let urlBaseApi = this.localStorageService.getIsVip
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";
    const sourceURL = rutaMicroservicio + "/api/v3/sources/details";

    const url = environment.CONSUME_API_DATA.toString().toLowerCase() === "true"
      ? `${urlBaseApi}/${sourceURL}/${country}/${domain}/${subDomain}`
      : `assets/mock/${country.toLocaleLowerCase()}/detail/DETAIL_${domain}_${subDomain}.json`;
    // console.log("String(dataObject.matchKey) ------->", String(dataObject.matchKey));
    const param = mode === 'refresh'
      ? new HttpParams().set('matchkey', String(dataObject.matchKey))
      : new HttpParams().set('matchkey', String(dataObject.matchKey).slice(0, -8));
    const objParams = {
      headers: this.getTokenToHeaders(),
      params: param,
    };

    return this.http.get(url, objParams)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  //TODO: servicio que se deberia Deprecar pero se utiliza en la configuracion del ABM para obtener la estructura antigua de la base de datos
  getStrucFirebase(domain: string, subDomain: string) {
    // cambio para ruta de Microservicios
    let rutaMicroservicio = environment.MICROSERVICIO.toString().toLowerCase() === "true"
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_GCP"]
      : "";
    const url = environment.CONSUME_API_ESTRUCTURA.toString().toLowerCase() === "true"
      ? `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}${rutaMicroservicio}/api/v1/gfd/data/DM_Rules_${this.country}/${domain}.${subDomain}`
      : `assets/mock/${this.country.toLowerCase()}/structure/STRUCT_${subDomain}_GKL.json`;
    return this.http.get<IResponseStructFireBase>(url)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  ///////////////////////////////////////////////////////////////////////////////////////

  /**
   * camelCase
   * PascalCase
   * snake_case
   * kebab-case
   */
  convertKebabCaseToPascalCase(str: string) {
    let arr = str.split('-');
    let capital = arr.map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase());
    return capital.join('');
  }
  convertKebabCaseToCamelCase(str: string) {
    return str.replace(/-./g, x => x[1].toUpperCase());
  }
  convertSnakeCaseToCamelCase(str: string) {
    return str.toLowerCase().replace(/_./g, x => x[1].toUpperCase());
  }
  convertSnakeCaseToPascalCase(str: string) {
    let arr = str.split('_');
    let capital = arr.map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase());
    return capital.join('');
  }

  // recibe un number
  encodeIup(iup: number) {
    let iupArray = iup?.toString().split('');
    return iupArray.map(e => String.fromCharCode(97 + Number(e))).join('');
  }

  // recibe un string
  encodeIupString(iup: string) {
    let iupArray = iup?.split('');
    return iupArray.map(e => String.fromCharCode(97 + Number(e))).join('');
  }

  applyTableFilters(rows: any, filters: QueryList<any>): any {
    let filterInUse = {};

    filters.forEach(filter => {
      if (filter.nativeElement.value) {
        let keyName = filter.nativeElement.name;
        filterInUse[keyName] = filter.nativeElement.value.toLowerCase();
      }
    });

    // console.log('filterInUse', filterInUse);
    for (let key in filterInUse) {
      rows = rows.filter(r =>
        r[key] === null || Number.isNaN(r[key]) || r[key] === undefined // !r[key]? no funciona en todos los casos, mejor especificar
          ? false
          : (r[key]).toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .includes(filterInUse[key].normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
      );
    }
    return rows;
  }

  // TODO: revisar, se está llamando este método desde el html, por tanto queda siempre pidiéndolo
  mostrarDataSelectGFD(itemNameValue: any, itemValue: any[], _itemName: string) {
    let salida = '';
    let itemNameValueFinal = itemNameValue;
    if (typeof itemNameValue == 'boolean') {
      itemNameValueFinal = Boolean(itemNameValue).toString();
    }
    const result = itemValue.find(({ value }) => value == itemNameValueFinal);
    if (result === undefined) { // itemNameValueFinal no encontrado en itemValue
      salida = itemNameValueFinal; // (itemNameValueFinal + ': -');
    } else {
      switch (itemNameValueFinal.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase()) {
        case result.text.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase():
        case 'TRUE':
        case 'FALSE':
          salida = result.text;
          break;
        default:
          salida = itemNameValueFinal + ': ' + result.text;
      }
    }
    return salida;
  }

  encodeList(data: any) {
    let encodedData;
    try {
      if (environment.IS_LOCAL.toString().toLowerCase() === "true") {
        encodedData = data;
      } else {
        encodedData = btoa(decodeURI(encodeURIComponent(JSON.stringify(data)))) + this.stringTokenLS; // encode a string
      }
    } catch (error) {
      encodedData = null;
    }
    return encodedData;
  }

  decodeList(encodedData: any) {
    let decodedData: any;
    if (environment.IS_LOCAL.toString().toLowerCase() === "true") {
      decodedData = encodedData;
    } else {
      try {
        decodedData = JSON.parse(decodeURIComponent(encodeURI(atob(encodedData.slice(0, -7))))); // decode the string
      } catch (error) {
        decodedData = null;
      }
    }
    return decodedData;
  }

  encodeString(data: any) {
    let encodedData: string;
    if (environment.IS_LOCAL.toString().toLowerCase() === "true") {
      encodedData = data;
    } else {
      try {
        encodedData = btoa(decodeURI(encodeURIComponent(data))) + this.stringTokenLS; // encode a string
      } catch (error) {
        encodedData = null;
      }
    }
    return encodedData;
  }

  decodeString(encodedData: any) {
    let decodedData: string;
    try {
      if (environment.IS_LOCAL.toString().toLowerCase() === "true") {
        decodedData = encodedData;
      } else {
        decodedData = decodeURIComponent(encodeURI(atob(encodedData.slice(0, -7)))); // decode the string
      }
    } catch (error) {
      decodedData = null;
    }
    return decodedData;
  }

  consoleLog() {
    if (environment.IS_LOCAL.toString().toLowerCase() === "true") {
      for (let argument of arguments) {
        // console.log(argument);
      }
      // console.log(arguments);
    }
  }

  currentCountryValues(countryTest?) {
    // console.log('%c ' + this.serviceName + " / " + 'currentCountryValues(countryTest?)', 'background: green; color: white');
    // console.log('countryTest : ', countryTest);

    let currentCountry = "null"
    if (countryTest) {
      // currentCountry = "cl"
    } else {
      if (this.localStorageService.getRegionSeleccionada != null) {
        currentCountry = this.localStorageService.getRegionSeleccionada.getCode();
      }
    }

    let currentCountryList = new Country;
    const country = COUNTRIES.find(elementPaisTodos => elementPaisTodos.code === currentCountry);
    if (country) {
      Object.assign(currentCountryList, country);
    }

    // console.log('listCountry', currentCountryList);

    return currentCountryList;
  }

  /**
   * Calcula los entitlement del Usuario
   */
  inicializaUser() {
    // alert('inicializaUser');
    let user: User;
    user = new User();
    // console.log('user0: ', user);
    let token: Token = {};
    let setPermit = [];

    // console.log('this.localStorageService.getIsVip', this.localStorageService.getIsVip);
    if (this.serviceToken.statusTokenUser() || this.localStorageService.getIsVip) {
      if (this.localStorageService.getIsVip) {
        token = JSON.parse(localStorage.getItem('tokenObj'));
      } else {
        token = this.serviceToken.getTokenUser();
      }
      let entitlement = [];


      let idToken = token.id_token; // rds externo undefined // this.localStorageService.getIsExternoRDS
      // Decodificar el JWT usando jwtDecode en lugar de atob para manejar correctamente Base64URL
      let objIdToken = jwtDecode<any>(idToken);
      user.setName((objIdToken.firstName === undefined)
        ? objIdToken.name
        : objIdToken.firstName + ' ' + objIdToken.lastName);
      user.setToken(token.access_token);
      // VIP: el email viene en sub (token emulado) o en mail; email puede estar indefinido
      user.setUser(this.localStorageService.getIsVip ? (objIdToken.sub || objIdToken.mail || objIdToken.email) : objIdToken.sub);
      user.setMail((objIdToken.mail === undefined)
        ? objIdToken.email
        : objIdToken.mail);

      localStorage.setItem('access_token', token.access_token);
      //localStorage.setItem('token_expiration',token.expires_in.toString())

      const expirationDate = new Date();
      const duracionToken = new Date(expirationDate.getTime() + 2 * 60 * 60 * 1000);
      localStorage.setItem('token_expiration', duracionToken.toISOString());

      // console.log('user1: ', user);
      // console.log('token: ', token);
      // console.log('arrayIdToken: ', arrayIdToken);
      // console.log('payload: ', payload);
      // console.log('payloadDeco: ', payloadDeco);
      // console.log('objIdToken: ', objIdToken);
      // console.log('objIdToken.groups: ', objIdToken.groups);

      try { // ejemplo: CN=py-datamaintenance_uat_admin,OU=datafabric,OU=appgroups,OU=accessmgmnt,DC=eis,DC=equifax,DC=com
        // console.log('typeof objIdToken.groups === ', typeof objIdToken.groups);
        if (typeof objIdToken.groups === 'string') {
          const newEntitlements = this.fillEntitlement(objIdToken.groups);
          entitlement.push(...newEntitlements);
        } else {
          objIdToken.groups.forEach(datos => {
            const newEntitlements = this.fillEntitlement(datos);
            entitlement.push(...newEntitlements);
          });
        }
      } catch (error) {
        console.log('Error fillEntitlement: ', error, objIdToken);
      }

      // console.log('entitlement2 --->', entitlement);
      let loginFilter = [];
      loginFilter = entitlement.filter(element => {
        return (
          element.ambiente === environment.ENVIRONMENT.toUpperCase() // filtra sólo los permisos del ambiente actual (NPE, UAT, PRD)
        );
      });

      // ordena por ambiente/country/roles
      loginFilter.sort((a, b) => {
        const ambienteComparison = a.ambiente.localeCompare(b.ambiente);
        if (ambienteComparison !== 0) {
          return ambienteComparison;
        }
        const countryComparison = a.country.localeCompare(b.country);
        if (countryComparison !== 0) {
          return countryComparison;
        }
        return a.roles.localeCompare(b.roles);
      });

      setPermit = loginFilter;

      // console.log('loginFilter', loginFilter);
      // console.log('user: ', user);
      // console.log('entitlement: ', entitlement);

    } else { // Mocks User
      user.setName('User');
      user.setToken('None');
      user.setUser('None');
      user.setMail('mail@mail.com');
      if (!(environment.USE_LOGIN.toString().toLowerCase() === "true")) {
        setPermit = LOGIN;
      }

    }
    user.setEntitlement(setPermit);
    // const filterCL = setPermit.filter(x => x.country === 'CL');

    // if (filterCL.length === 1 && filterCL.some(x => x.roles === 'BOLAB')) {
    //     const permit = [filterCL[0].roles];
    //     this.setSourcesSpecific(permit);
    // }

    // // console.log("filtro", filterCL);

    return user;
  }

  fillEntitlement(groupAll: string): any[] {
    const newEntitlements: any[] = [];
    const permissionAllRoles = "ADMIN";
    if (this.localStorageService.getIsVip) {

      newEntitlements.push({ // emula login con credenciales en VIP
        "country": this.localStorageService.getCountryString,
        "ambiente": "NPE",
        "roles": permissionAllRoles // "ADMIN"
      });
      newEntitlements.push({
        "country": this.localStorageService.getCountryString,
        "ambiente": "UAT",
        "roles": permissionAllRoles // "ADMIN"
      });
      newEntitlements.push({
        "country": this.localStorageService.getCountryString,
        "ambiente": "PRD",
        "roles": permissionAllRoles // "ADMIN"
      });
    } else if (this.localStorageService.getIsExternoRDS) {
      newEntitlements.push({ // emula login con credenciales en VIP
        "country": this.localStorageService.getCountryString,
        "ambiente": "NPE",
        "roles": permissionAllRoles // "ADMIN"
      });
      newEntitlements.push({
        "country": this.localStorageService.getCountryString,
        "ambiente": "UAT",
        "roles": permissionAllRoles // "ADMIN"
      });
      newEntitlements.push({
        "country": this.localStorageService.getCountryString,
        "ambiente": "PRD",
        "roles": permissionAllRoles // "ADMIN"
      });
    } else {
      // console.log('groupAll', groupAll);
      let salidaCn = groupAll.split(',').find(element => element.includes('CN'));
      if (salidaCn) {
        let salidaPaisAmbUser = salidaCn.split('=')[1];
        let arrayPaisAmbUser = salidaPaisAmbUser.split('_');
        // console.log('salidaCn salidaPaisAmbUser arrayPaisAmbUser', salidaCn, salidaPaisAmbUser, arrayPaisAmbUser);
        // console.log('arrayPaisAmbUser', arrayPaisAmbUser);

        // console.log("environment.ENVIRONMENT", environment.ENVIRONMENT);
        if (arrayPaisAmbUser[0].includes('datamaintenance') && arrayPaisAmbUser[1].includes(environment.ENVIRONMENT)) {
          const roles = arrayPaisAmbUser.length > 3
            ? arrayPaisAmbUser[2].toUpperCase().concat('_', arrayPaisAmbUser[3].toUpperCase())
            : arrayPaisAmbUser[2].toUpperCase();
          newEntitlements.push({
            "country": arrayPaisAmbUser[0].split('-')[0].toUpperCase(),
            "ambiente": arrayPaisAmbUser[1].toUpperCase(),
            "roles": roles
          });
        }
      }
    }

    return newEntitlements;
  }

  addGuionFirstYear(date: string): string {
    if (date) {
      let anio = date.substring(0, 4);
      let mes = date.substring(4, 6);
      let dia = date.substring(6, 8);
      return anio + "-" + mes + "-" + dia;
    } else {
      return "-";
    }
  }

  addGuionLastYear(date: string): string {
    if (date) {
      let anio = date.substring(0, 4);
      let mes = date.substring(4, 6);
      let dia = date.substring(6, 8);
      return dia + "-" + mes + "-" + anio;
    } else {
      return "-";
    }
  }

  ageForDate(dateBirthday: string): string {
    if (dateBirthday) {
      let hoy = new Date();
      let cumple = new Date(dateBirthday);

      let edad = hoy.getFullYear() - cumple.getFullYear();
      let m = hoy.getMonth() - cumple.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumple.getDate())) {
        edad--;
      }
      return edad.toString();
    } else {
      return "-";
    }
  }

  getAttributeName(persona: any, text: string): string {
    let str: string = persona[text] || '';
    switch (text) {
      case 'nacimientoFh':
        if (str != null && str != undefined && str != "") {
          str = str.substring(6, 8).concat('/')
            .concat(str.substring(4, 6)).concat('/')
            .concat(str.substring(0, 4));
        } else {
          str = "--";
        }
        break;
      case 'tipoPersona':
        str = str == 'S'
          ? 'Sucesión'
          : str;
        break;
      case 'entityKey':
        if (this.localStorageService.getMenuApp?.title === OptionMenuApps.DM) {
          str = str.substring(0, 5) + '...' + str.substring(str.length - 5);
          // } else if (this.localStorageService.getMenuApp?.title === OptionMenuApps.MERGE) {
          //   str = str.substring(0, 7) + '...' + str.substring(str.length - 7);
        }
        break;
      case 'entityKeyTooltip':
        str = persona['entityKey'];
        break;
      default:
        break;
    };
    return (str === null || str === undefined)
      ? ''
      : str.toString();
  }

  topPage() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  /**
   * Retorna la parte endpoint del string doble journaling.endpoint
   * EJ: OFFICIAL_REGISTER_TSE.OFFICIAL_REGISTER_TSE_ENDPOINT
   */
  getEndpoint(journalingEndpoint: string): string {
    let splitArray = journalingEndpoint.split('.');
    if (splitArray.length === 1) {
      return splitArray[0];
    } else {
      return splitArray[1];
    }
  }

  /**
   * Retorna la parte JO del string doble journaling.endpoint
   */
  getJournaling(journalingEndpoint: string): string {
    return journalingEndpoint.split('.')[0];
  }

  /**
   * Retorna las fuentes especificas en el menu
   */
  getSourcesSpecific() {
    return this.sourcesSpecific;
  }

  setSourcesSpecific(data: Array<string>) {
    this.sourcesSpecific = data;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Para formato de fecha yyyyMMdd
   */
  getDateFromString(stringDate: string) {
    let dateString = stringDate;
    let year = dateString.substring(0, 4);
    let month = dateString.substring(4, 6);
    let day = dateString.substring(6, 8);

    return new Date(+year, +month - 1, +day);
  }

  getDateWithoutHyphen(stringDate: string) {
    let dateString = stringDate.split("-");
    let year = dateString[0];
    let month = dateString[1];
    let day = dateString[2].split(" ")[0];

    return new Date(+year, +month - 1, +day);
  }

  // Utilidad para calcular la fecha mayor
  getMaxDate(dates) {
    if (dates.length > 0) {
      let max_date: Date = this.getDateFromString(dates[0].inicio_fh);
      let index: number
      for (const key in dates) {
        let fecha = this.getDateFromString(dates[key].inicio_fh)

        if (fecha > max_date) {
          max_date = fecha;
          index = +key
        }
      }
      return dates[index]
    }
  }

  getCurrentPerson() {
    this.localStorageService.getPersonaSelectedObs.pipe(first()).subscribe(p => {
      if (p) {
        this.currentPersona = p;
      } else {
        this.notificationService
          .showErrorWithTime('No se encuentra una persona seleccionada. Se redirigirá a la pantalla de búsqueda.', 5000)
          .afterDismissed().subscribe(() => {
            this.router.navigateByUrl(
              this.localStorageService.getIsVip
                ? environment.URL_RETURN_APP_VIP
                : this.localStorageService.getIsExternoRDS
                  ? environment.URL_RETURN_APP_RDS
                  : environment.URL_RETURN_APP
            );
          });
      }
    });
  }

  //UPDATE genérico para fuentes e histórico
  updateSource(source: string, form: FormGroup) {
    // console.log('shared updateSource', source, form)
    const dataToSave = this.createUpdateObject(form);
    const urlFoldersMenu = this.localStorageService.configInit['F_URL_FOLDERS_MENU'];

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      let urlBaseApi = (this.localStorageService.getIsVip)
        ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
        : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
      return this.http.patch<any>(
        `${urlBaseApi}${rutaMicroservicio}${urlFoldersMenu}/ar/${source}`, dataToSave, this.objParams)
        .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        );
    } else {
      return of({ "type": "mockResponse", "data": dataToSave.changeDetails });
    }
  }

  createUpdateObject(form: FormGroup) {
    let dms: DMS;
    let changeDetails: Array<ChangeDetails> = [];
    let observations: Array<ChangeObservations> = [];

    for (const key in form.controls) {
      if (form.get([key]).dirty && key !== 'historicos') {
        changeDetails.push(
          new ChangeDetails(key, form.get([key]).value)
        );
      }
      if (form.get([key]).dirty && key == 'historicos') {
        changeDetails.push(
          new ChangeDetails(key, form.get('historicos').value)
        );
      }
    }
    observations.push(new ChangeObservations(form.get('matchKey').value, form.get('rowKey').value));
    dms = new DMS(changeDetails, observations);
    // console.log("dms : ", dms);

    return dms;
  }

  createUpdateObjectBasePositiva(form: FormGroup) {
    let dms: DMS;
    let changeDetails: Array<ChangeDetails> = [];
    let observations: Array<ChangeObservations> = [];

    for (const key in form.controls) {
      if (form.get([key]).dirty && key !== 'historicos') {
        changeDetails.push(
          new ChangeDetails(key, form.get([key]).value)
        );
      }
      if (form.get([key]).dirty && key == 'historicos') {
        changeDetails.push(
          new ChangeDetails(key, form.get('historicos').value)
        );
      }
    }
    observations.push(new ChangeObservations(form.get('matchKey').value, form.get('operation_id')?.value ?? null));
    dms = new DMS(changeDetails, observations);
    // console.log("dms : ", dms);

    return dms;
  }

  //DELETE genérico para fuentes (DEPRECADO UTILIZAR fuenteDinamicaService.deleteFuenteDinamicaSource)
  deleteSource(source: string, listToDelete: Array<any>, countryDelete) {
    const objParams = {
      headers: this.getTokenToHeaders()
    };

    let params = JSON.parse(JSON.stringify(objParams));
    let matchKey = "";
    let matchKey2 = "";
    let matchKeyD = "";
    let icantidad = 1;
    const dataToDelete = {
      observations: {},
      internalOp: "SOFT_DELETE",
    };
    let subDominio = "";

    if (listToDelete.length == 1) {
      listToDelete.forEach(el => {
        subDominio = el.tipo;
        matchKey = "isEqual('ingestionHeader.matchKey'," + "'" + el.matchKey + "')";
        dataToDelete.observations = ({ matchKey });
      });
    } else {
      matchKeyD = "";
      matchKey = "";
      listToDelete.forEach(el => {
        if (icantidad <= listToDelete.length) {
          subDominio = el.tipo;
          if (icantidad == 1) {
            matchKey = "isEqual('ingestionHeader.matchKey'," + "'" + el.matchKey + "')";
          } else {
            matchKeyD = matchKeyD + ".or(" + "isEqual('ingestionHeader.matchKey'," + "'" + el.matchKey + "'))";
          }
        }
        icantidad++
      });
      matchKey2 = matchKey + matchKeyD;
      matchKey = "";
      matchKey = matchKey2;

      dataToDelete.observations = ({ matchKey });
    }
    let usuarioSoftDelete = this.localStorageService.dataLogin.getUser();

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_DMS"]
      : "";

    const url = this.localStorageService.getIsVip
      ? `${this.localStorageService.configInit["F_OKTA_URL_BASE_API"]}/api-vip/dms-service/v1/dms/${countryDelete.toUpperCase()}/${source}/${subDominio}/${usuarioSoftDelete}`
      : `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}${rutaMicroservicio}/api/v1/dms/${countryDelete.toUpperCase()}/${source}/${subDominio}/${usuarioSoftDelete}`
    return this.http.post<any>(url, dataToDelete, params)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  // updateDis
  updateDis(source: string, _form: FormGroup, dataToSave: any, service?: any) {
    const urlDisVipBackGKL = this.localStorageService.configInit['F_URLDISVIPBACKGKL'];
    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_DIS"] + "/"
      : "";

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      switch (service) {
        case "gkl":
          // ruta VIP
          let baseUrl = (this.localStorageService.getIsVip)
            ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
            : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

          let sourceUrl = (this.localStorageService.getIsVip)
            ? urlDisVipBackGKL
            : rutaMicroservicio + this.localStorageService.configInit["F_URL_DIS_BACK_GKL"];
          const country = "AR";
          return this.http.post<any>(
            `${baseUrl}/${sourceUrl}/${country}/${source}`, dataToSave, this.objParams)
            .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
            );
        case "tkl":
          return this.http.post<any>(
            `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}/api/v1/DIS/ar/${source}`, dataToSave, this.objParams)
            .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
            );
        default:
          // console.log("guardando default dis");
          return this.http.post<any>(
            `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}/api/v1/DIS/ar/${source}`, dataToSave, this.objParams)
            .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
            );
      }
    } else {
      // return empty observable
      return of({ "type": "mockResponse", "data": dataToSave });
    }
  }

  updateDisBp(country: string, source: string, _form: FormGroup, dataToSave: any, service?: any) {
    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_DIS"] + "/"
      : "";

    const urlDisVipBackGKL = this.localStorageService.configInit['F_URLDISVIPBACKGKL'];

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      switch (service) {
        case "gkl":
          // ruta VIP
          let baseUrl = (this.localStorageService.getIsVip)
            ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
            : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

          let sourceUrl = (this.localStorageService.getIsVip)
            ? urlDisVipBackGKL
            : rutaMicroservicio + this.localStorageService.configInit["F_URL_DIS_BACK_GKL"];
          // console.log('dataToSave DIS PY', dataToSave)
          return this.http.post<any>(
            `${baseUrl}/${sourceUrl}/${country}/${source}`, dataToSave, this.objParams)
            .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
            );
        case "tkl":
          return this.http.post<any>(
            `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}/api/v1/DIS/py/${source}`, dataToSave, this.objParams)
            .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
            );
        default:
          // console.log("guardando default dis");
          return this.http.post<any>(
            `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}/api/v1/DIS/py/${source}`, dataToSave, this.objParams)
            .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
            );
      }
    } else {
      // return empty observable
      return of({ "type": "mockResponse", "data": dataToSave });
    }
  }

  logUpadteFuenteManual(country: string, domain: string, subDomain: string, username: string, dataToSaveLog: any, matchkey: string) {
    let urlBaseApi: string;
    let apiVip: string;
    let sourceUrl: string;
    let userFinal: string;
    let logString: string;

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_GCP"]
      : "";

    if (this.localStorageService.getIsVip) {
      urlBaseApi = this.localStorageService.configInit["F_VIP_URL_BASE_API"];
      apiVip = 'vip/gcp-service';

      sourceUrl = '';
      userFinal = username.split('@')[0];
      logString = 'reg';
    } else {
      urlBaseApi = this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
      apiVip = 'api';
      sourceUrl = '';
      userFinal = username;
      logString = 'log';
      if (environment.MICROSERVICIO.toString().toLowerCase() === "true") {
        apiVip = rutaMicroservicio + '/api'
      }

    }
    return this.http.post<any>(`${urlBaseApi}/${apiVip}/v1/${sourceUrl}${logString}/${country.toLocaleUpperCase()}/${subDomain}/${userFinal}/${encodeURIComponent(matchkey)}`, JSON.stringify(dataToSaveLog), this.objParams).
      pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  getSchemasDataViews(subDomain: string) {
    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_DIS"] + "/"
      : "";

    // ruta VIP
    let baseUrl = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const sourceUrl = this.localStorageService.getIsVip
      ? this.localStorageService.configInit["F_VIP_URL_DATAVIEW"]
      : rutaMicroservicio + this.localStorageService.configInit["F_URL_DATAWIEW"];
    const url = `${baseUrl}/${sourceUrl}/${subDomain}`;

    return this.http.get<any>(url).
      pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)))
  }

  getDetails(EmploymentObject: any, mode?: any, service?: any) {
    let source = "EMPLOYMENT_STATUS";
    // FIRST STAGE, EDIT MODE AND CREATE MODE
    if (mode && environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      switch (mode) {
        case 'edit':
          // console.log("edit mode : ", String(EmploymentObject[0].matchKey).slice(0, -12))
          const paramRefresh = new HttpParams().set('matchkey', String(EmploymentObject[0].matchKey).slice(0, -12));
          const objParamsRefresh = {
            headers: this.getTokenToHeaders(),
            params: paramRefresh
          };

          // cambio para ruta de Microservicios
          let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
            ? this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"] + "/"
            : "";

          let urlBaseApi = (this.localStorageService.getIsVip)
            ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
            : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
          let sourceUrl = (this.localStorageService.getIsVip)
            ? "vip/v3/sources/details"
            : rutaMicroservicio + "api/v3/sources/details";
          const country = "AR";
          const subDomain = "AR_IDENTITY"
          return this.http.get(
            `${urlBaseApi}/${rutaMicroservicio}/${sourceUrl}/${country}/${subDomain}/` + source, objParamsRefresh)
            .pipe(
              timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
            )
        default:
          //NOTHING TO DO HERE
          break;
      }
    }
  }


  getDetailsManuals(dataObject: any, country: string, domain: string, subDomain: string, mode?: any) {
    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"] + "/"
      : "";

    const baseUrl = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

    const versionUrl = 'v3';
    let journalingUrl = this.localStorageService.getIsVip
      ? 'vip/journaling-service'
      : 'api';

    if (environment.MICROSERVICIO.toString().toLowerCase() === "true" && journalingUrl == 'api') {
      journalingUrl = rutaMicroservicio + 'api'
    }

    const sourceUrl = `${journalingUrl}/${versionUrl}/sources/details`;

    const url = environment.CONSUME_API_DATA.toString().toLowerCase() === "true"
      ? `${baseUrl}/${sourceUrl}/${country}/${domain}/${subDomain}`
      : `assets/mock/${country.toLocaleLowerCase()}/detail/DETAIL_${domain}_${subDomain}.json`;

    const param = mode === 'refresh'
      ? new HttpParams().set('matchkey', String(dataObject.matchKey))
      : new HttpParams().set('matchkey', this.generatematchKeyManuals(domain, dataObject.matchKey));
    const objParams = {
      headers: this.getTokenToHeaders(),
      params: param
    };

    return this.http.get(
      url, objParams
    ).pipe(
      timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
    )
  }

  getDecrypt(decrypt: string) {
    // Variables URL http://localhost:8080/gcp-service/api/v1/decrypt?value=
    decrypt = 'zJJwYeCFvSBnLOXkNQbBnmJtqM3Td0eT/6jczIYDn7UXZPIjRxhxOwi31g=='
    const rutaMicroservicio = environment.MICROSERVICIO.toString().toLowerCase() === "true"
      ? "/gcp-service"
      : "";
    // comment const urlService = `${this.urlService.getURL("/datamaintenance-service")}/v1/hashing/${inputVaue.toString()}/${this.countrySelected.getCode().toUpperCase()}`;
    const urlService = `${this.urlService.getURL(rutaMicroservicio)}/v1/decrypt`;
    // Llamada al servicio
    const param = new HttpParams().set('value', decrypt);
    const objParams = {
      headers: this.getTokenToHeaders(),
      params: param
    };

    return this.http.get(
      urlService, objParams
    ).pipe(
      timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
    )
  }

  generatematchKeyManuals(domain: string, matchkey: String) {
    let matchKey = "";
    if (domain === "AR_BUREAU_EXCH") {
      matchKey = matchkey.slice(0, -7);
    } else if (domain === "AR_CREDIT") {
      matchKey = matchkey.slice(0, -12);
    } else {
      matchKey = matchkey.slice(0, -9);
    }
    return matchKey;
  }

  // Método para inicializar las fuentes manuales
  //  variables que pueden fallar al cambiarse desde GFD a Manuales o viceversa
  initSourceManual() {
    this.localStorageService.setDataSourceSelected = null; // inicializa _dataSourceSelected en las fuentes manuales
  }

  // Borrar esto luego de la limpieza
  escapeSpecialChars(str) {
    return str
      .replaceAll('\"', '\\"')
      .replaceAll('\n', '\\n');
  }

  // Borrar esto luego de la limpieza
  escapeSpecialCharsDIS(str) { // revisar si provoca problemas
    return str
      .replaceAll('\\', '\\\\');
  }

  getInit() {
    const env = environment.ENVIRONMENT;

    const url = !(environment.IS_LOCAL.toString().toLowerCase() === 'true')
      ? `assets/data/init/init.${env}.json`
      : `assets/data/init/init.dev.json`;

    return this.http.get(url);
  }

  getConfigInit(baseUrl: string): Observable<any> {
    const url = !(environment.IS_LOCAL.toString().toLowerCase() === 'true')
      ? `https://internal-${baseUrl}/facade-im/variables`
      : `/facade-im/variables`;

    return this.http.get(url).pipe(
      retry({
        count: 3,
        delay: 1500,
      }),
      catchError(error => {
        console.error(`getConfigInit falló después de los reintentos para la URL: ${url}`, error);
        return throwError(() => new Error(`Fallo al obtener la configuración inicial de ${url} después de reintentos.`));
      })
    );
  }

  getConfigInitVip(): Observable<any> {
    const url = (environment.CONSUME_API_DATA.toString().toLowerCase() === "true")
      ? `${this.urlService.getURL('')}/variables`
      : `/facade-im/variables`;

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(url, { headers }).pipe(
      retry({
        count: 3,
        delay: 1500,
      }),
      catchError(error => {
        console.error(`getConfigInitVip falló después de los reintentos para la URL: ${url}`, error);
        return throwError(() => new Error(`Fallo al obtener la configuración VIP de ${url} después de reintentos.`));
      })
    );
  }

  transformDataMenu(dataMenu: any): any {
    const groupedData = dataMenu['items']
      .filter(item => item.domainJO && item.subDomainJO)
      .reduce((acc, item) => {
        const domain = item.domainJO;
        const subdomain = item.subDomainJO;
        if (!acc.has(domain)) {
          acc.set(domain, []);
        }
        acc.get(domain).push(subdomain);
        return acc;
      }, new Map<string, string[]>());

    const transformedData = Array.from(groupedData.entries()).map(([domain, subdomains]) => ({ domain, subdomains }));

    transformedData.sort((a, b) => a.domain.localeCompare(b.domain));

    return transformedData;
  }

  // Función que limpia caracteres escapados de forma genérica
  public cleanEscapedNewlines(data: any): any {
    if (!data) {
      return data;
    }

    // Si 'data' es un array, recorre cada objeto dentro del array
    if (Array.isArray(data)) {
      return data.map(item => this.cleanEscapedNewlines(item));
    }

    // Si 'data' es un objeto, recorre cada una de sus propiedades
    if (typeof data === 'object') {
      const cleanedData = {};
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const value = data[key];
          // Si el valor es una string y contiene la secuencia de escape, la reemplaza
          if (typeof value === 'string' && value.includes('\\n')) {
            cleanedData[key] = value.replace(/\\n/g, '\n');
          } else {
            // Si no es una string con escape, mantiene el valor original
            cleanedData[key] = value;
          }
        }
      }
      return cleanedData;
    }

    // Para otros tipos de datos, no hace nada
    return data;
  }

  compareObjectsWithValues(obj1: any, obj2: any): { atributo: string, objeto1: any, objeto2: any }[] {
    const diffs: { atributo: string, objeto1: any, objeto2: any }[] = [];
    const allKeys = Array.from(new Set([...Object.keys(obj1), ...Object.keys(obj2)]));
    for (const key of allKeys) {
      if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
        diffs.push({
          atributo: key,
          objeto1: obj1[key],
          objeto2: obj2[key]
        });
      }
    }
    return diffs;
  }
  ///// buscador global /////
  getSearchGlobal(country: string, type: string, method: string) {
    const url = `/gcp-service/api/v1/buscador/${country}/${type}/DEFAULT`//`https://internal-datamaintenance-dev.npe.intl.la-nane1.gcp.efx/gcp-service/api/v1/buscador/charge/AR/INTERNO/DEFAULT`;
    return this.http.get<any>(url)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)), catchError(err => of({ error: true, err, payload: { error: [] } })));
  }

  deleteSearhcGlobal(id: string, country: string, type: string, method: string) {
    const baseUrl = ``;
    const url = `/gcp-service/api/v1/buscador/${country}/${type}/DEFAULT/items/${id}`;
    return this.http.delete(url).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)), catchError(err => of({ error: true, err, payload: { error: [] } })));;
  }

  postSearchGlobal(body: any, country: string, type: string, method: string) {
    const baseUrl = ``;
    const url = `/gcp-service/api/v1/buscador/charge/${country}/${type}/DEFAULT`;
    return this.http.post(url, body).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)), catchError(err => of({ error: true, err, payload: { error: [] } })));;
  }

  /**
   * Serializa un valor según su tipo Avro.
   * Implementa la lógica completa de serialización Avro con soporte para tipos nullable,
   * arrays, records, y tipos primitivos.
   * Versión unificada usada por edición individual y masiva.
   */
  serializeAvroValue(avroType: any, value: any): any {
    // PRIMERO: Verificar si el valor es null/undefined, sin importar el tipo
    if (value === null || value === undefined) {
      return null;
    }


    // SEGUNDO: Si el valor es el string "NULL" y el tipo es string, convertir a null
    if (value === "NULL") {
      const typeString = Array.isArray(avroType)
        ? this.optionType(avroType.find(t => t !== "null"))
        : (typeof avroType === "object" ? this.optionType(avroType) : avroType);

      if (typeString === "string") {
        return null;
      }
    }

    // Si el tipo es un array (ej: ["string", "null"], ["int", "null"])
    if (Array.isArray(avroType)) {
      const nonNullType = avroType.find(t => t !== "null");
      const typeString = typeof nonNullType === 'object' ? nonNullType.type : nonNullType;

      // Si el valor es "" (string vacío) y el tipo NO es "string", convertir a null
      if (value === "" && typeString !== "string") {
        return null;
      }

      // Si el tipo es objeto (ej: { type: "array" })
      if (typeof nonNullType === "object" && nonNullType.type === "array") {
        const isNullable = avroType.some(t => t === "null" || null);

        // Si es un array de records, procesar cada elemento recursivamente
        if (nonNullType.items && nonNullType.items.type === "record" && Array.isArray(value)) {
          const recordFields = nonNullType.items.fields;
          const valueArray = value.map(item => {
            const processedItem = {};
            recordFields.forEach(field => {
              const fieldValue = item[field.name];
              processedItem[field.name] = this.serializeAvroValue(field.type, fieldValue);
            });
            return processedItem;
          });

          const arrayNomandatory = {};
          arrayNomandatory[nonNullType.type] = valueArray;
          return isNullable ? arrayNomandatory : valueArray;
        }

        // Fallback: array de objetos sin metadata de record → envolver cada campo string en {"string": valor}
        if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
          const wrappedArray = value.map(item => {
            const processedItem = {};
            Object.keys(item).forEach(key => {
              const fieldValue = item[key];
              if (fieldValue === null || fieldValue === undefined) {
                processedItem[key] = null;
              } else if (typeof fieldValue === 'string') {
                processedItem[key] = { "string": fieldValue };
              } else {
                processedItem[key] = fieldValue;
              }
            });
            return processedItem;
          });
          const arrayWrapper = {};
          arrayWrapper[nonNullType.type] = wrappedArray;
          return isNullable ? arrayWrapper : wrappedArray;
        }
        return value;
      }

      // Si el tipo es objeto (ej: { type: "int" })
      if (typeof nonNullType === "object" &&
        ["string", "int", "boolean", "double", "float", "long", "BigInt"].includes(nonNullType.type)) {
        const converted = this.convertFormatDIS(nonNullType.type, value);
        return { [nonNullType.type]: converted };
      }

      // Para tipos simples
      const converted = this.convertFormatDIS(typeString, value);
      return { [typeString]: converted };
    }

    // Si es objeto Avro tipo array o record
    if (typeof avroType === "object") {
      const typeString = avroType.type;

      if (value === "" && typeString !== "string") {
        return null;
      }

      if (avroType.type === "array") {
        // Si es un array de records, procesar cada elemento recursivamente
        if (avroType.items && avroType.items.type === "record" && Array.isArray(value)) {
          const recordFields = avroType.items.fields;
          return value.map(item => {
            const processedItem = {};
            recordFields.forEach(field => {
              const fieldValue = item[field.name];
              processedItem[field.name] = this.serializeAvroValue(field.type, fieldValue);
            });
            return processedItem;
          });
        }

        // Fallback: array de objetos sin metadata de record → envolver cada campo string en {"string": valor}
        if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
          return value.map(item => {
            const processedItem = {};
            Object.keys(item).forEach(key => {
              const fieldValue = item[key];
              if (fieldValue === null || fieldValue === undefined) {
                processedItem[key] = null;
              } else if (typeof fieldValue === 'string') {
                processedItem[key] = { "string": fieldValue };
              } else {
                processedItem[key] = fieldValue;
              }
            });
            return processedItem;
          });
        }
        return value;
      }

      if (avroType.type === "record") {
        return value;
      }

      if (["string", "int", "boolean", "double", "float", "long", "BigInt"].includes(avroType.type)) {
        return this.convertFormatDIS(avroType.type, value);
      }

      return value;
    }

    // Si es tipo simple ("string", "int", etc)
    if (value === "" && avroType !== "string") {
      return null;
    }

    return this.convertFormatDIS(avroType, value);
  }

  /**
   * Parsea un string tipo ['ADMIN', ...] a array de roles seguro (sin eval)
   */
  public parseRolesArray(raw: any): string[] {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    try {
      const jsonReady = typeof raw === 'string' ? raw.replace(/'/g, '"') : raw;
      const parsed = JSON.parse(jsonReady);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

}
